import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';

const withAuth = (WrappedComponent: React.ComponentType<any>) => {
  return (props: any) => {
    const user = localStorage.getItem('user'); // Example, replace with actual auth logic
    const location = useLocation();
    if (!user) {
      return (
        <Navigate
          to='/login'
          state={{ from: location }}
        />
      );
    }

    return <WrappedComponent {...props} />;
  };
};

export default withAuth;
